// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperAdminUserNotifications .table-responsive {
  overflow: visible;
}

.SuperAdminUserNotifications .react-datepicker-popper {
  z-index: 10000 !important;
}

.SuperAdminUserNotificationsJsonBlock {
  max-height: 420px;
  overflow: auto;
  padding: 12px;
  margin: 8px 0 0;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
}

.SuperAdminUserNotificationsModalBackdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background: rgba(0, 0, 0, 0.35);
}

.SuperAdminUserNotificationsModal {
  position: fixed;
  top: 40px;
  left: 50%;
  z-index: 1050;
  width: 92%;
  max-width: 1100px;
  max-height: calc(100vh - 80px);
  overflow: auto;
  transform: translateX(-50%);
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

.SuperAdminUserNotificationsModalHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #dee2e6;
}

.SuperAdminUserNotificationsModalBody {
  padding: 16px;
}

.SuperAdminUserNotificationsDetailsGrid {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 8px 16px;
}

.SuperAdminUserNotificationsDetailsRow {
  display: contents;
}

.SuperAdminUserNotificationsDetailsLabel {
  font-weight: 600;
  color: #495057;
}

.SuperAdminUserNotificationsDetailsValue {
  min-width: 0;
  word-break: break-word;
}

.SuperAdminUserNotificationsMessageGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 12px;
}

.SuperAdminUserNotificationsMessageCard {
  padding: 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.SuperAdminUserNotificationsMessageTitle {
  margin-bottom: 8px;
  font-weight: 700;
}

.SuperAdminUserNotificationsMessageBody {
  max-height: 240px;
  overflow: auto;
  padding: 8px;
  margin: 0;
  background: #f8f9fa;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
}

.SuperAdminUserNotificationsChannelTable {
  background: #fff;
}

.SuperAdminUserNotificationsChannelTable th,
.SuperAdminUserNotificationsChannelTable td {
  vertical-align: top;
}

.SuperAdminUserNotificationsDetailsJson {
  margin-bottom: 10px;
}

.SuperAdminUserNotificationsDetailsJson summary {
  cursor: pointer;
  font-weight: 600;
}

@media (max-width: 768px) {
  .SuperAdminUserNotificationsDetailsGrid {
    grid-template-columns: 1fr;
  }

  .SuperAdminUserNotificationsDetailsLabel {
    margin-top: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminApp/User/Notifications/SuperAdminUserNotifications.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".SuperAdminUserNotifications .table-responsive {\n  overflow: visible;\n}\n\n.SuperAdminUserNotifications .react-datepicker-popper {\n  z-index: 10000 !important;\n}\n\n.SuperAdminUserNotificationsJsonBlock {\n  max-height: 420px;\n  overflow: auto;\n  padding: 12px;\n  margin: 8px 0 0;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.SuperAdminUserNotificationsModalBackdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background: rgba(0, 0, 0, 0.35);\n}\n\n.SuperAdminUserNotificationsModal {\n  position: fixed;\n  top: 40px;\n  left: 50%;\n  z-index: 1050;\n  width: 92%;\n  max-width: 1100px;\n  max-height: calc(100vh - 80px);\n  overflow: auto;\n  transform: translateX(-50%);\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n}\n\n.SuperAdminUserNotificationsModalHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.SuperAdminUserNotificationsModalBody {\n  padding: 16px;\n}\n\n.SuperAdminUserNotificationsDetailsGrid {\n  display: grid;\n  grid-template-columns: 180px 1fr;\n  gap: 8px 16px;\n}\n\n.SuperAdminUserNotificationsDetailsRow {\n  display: contents;\n}\n\n.SuperAdminUserNotificationsDetailsLabel {\n  font-weight: 600;\n  color: #495057;\n}\n\n.SuperAdminUserNotificationsDetailsValue {\n  min-width: 0;\n  word-break: break-word;\n}\n\n.SuperAdminUserNotificationsMessageGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 12px;\n}\n\n.SuperAdminUserNotificationsMessageCard {\n  padding: 12px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.SuperAdminUserNotificationsMessageTitle {\n  margin-bottom: 8px;\n  font-weight: 700;\n}\n\n.SuperAdminUserNotificationsMessageBody {\n  max-height: 240px;\n  overflow: auto;\n  padding: 8px;\n  margin: 0;\n  background: #f8f9fa;\n  border-radius: 4px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-size: 12px;\n}\n\n.SuperAdminUserNotificationsChannelTable {\n  background: #fff;\n}\n\n.SuperAdminUserNotificationsChannelTable th,\n.SuperAdminUserNotificationsChannelTable td {\n  vertical-align: top;\n}\n\n.SuperAdminUserNotificationsDetailsJson {\n  margin-bottom: 10px;\n}\n\n.SuperAdminUserNotificationsDetailsJson summary {\n  cursor: pointer;\n  font-weight: 600;\n}\n\n@media (max-width: 768px) {\n  .SuperAdminUserNotificationsDetailsGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .SuperAdminUserNotificationsDetailsLabel {\n    margin-top: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
